import { render, staticRenderFns } from "./layer-statuses-config-modal.vue?vue&type=template&id=47cc0cb0&scoped=true"
import script from "./layer-statuses-config-modal.vue?vue&type=script&lang=js"
export * from "./layer-statuses-config-modal.vue?vue&type=script&lang=js"
import style0 from "./layer-statuses-config-modal.vue?vue&type=style&index=0&id=47cc0cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cc0cb0",
  null
  
)

export default component.exports